import { useLocation } from 'react-router-dom'
import { YomeHash } from 'src/constants/navigate.constants'

// eslint-disable-next-line import/prefer-default-export
export const useHashUrl = (hash: typeof YomeHash[keyof typeof YomeHash]) => {
  const { search } = useLocation()

  return `${search}${hash}`
}
